/**
 * Helpers
 */
const selectors = {
    body: 'body',
    hero: '.js-hero',
    footer: '.js-footer'
};

const classes = {
    isTeathered: 'is-teathered',
    notTop: 'not-top'
};

/**
 * Main
 */
const body = document.querySelector(selectors.body);
const hero = document.querySelector(selectors.hero);
const footer = document.querySelector(selectors.footer);

let teatherPoint;
let unTeatherPoint;

const getTeatherPoint = (el) => {
    teatherPoint = el.scrollHeight + el.getBoundingClientRect().top + window.scrollY;
};

const getUnTeatherPoint = (el) => {
    unTeatherPoint = el.getBoundingClientRect().top + window.scrollY;
};

let scrollDebump;
const toggleHeader = () => {
    if (scrollDebump || window.innerWidth < 1024) return;
    scrollDebump = setTimeout(() => {
        // Header disappears when scrolling down
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            body.classList.add(classes.notTop);
            if (
                document.body.scrollTop > teatherPoint ||
                document.documentElement.scrollTop > teatherPoint
            ) {
                body.classList.add(classes.isTeathered);

                if (
                    document.body.scrollTop > unTeatherPoint ||
                    document.documentElement.scrollTop > unTeatherPoint
                ) {
                    body.classList.remove(classes.isTeathered);
                }
            } else {
                body.classList.remove(classes.isTeathered);
            }
        } else {
            body.classList.remove(classes.notTop);
        }
        scrollDebump = null;
    }, 100);
};

if (hero) {
    document.addEventListener('DOMContentLoaded', getTeatherPoint(hero));
    window.addEventListener('resize', () => {
        if (window.innerWidth > 1023) {
            getTeatherPoint(hero);
        }
    });
}

document.addEventListener('DOMContentLoaded', getUnTeatherPoint(footer));
document.addEventListener('DOMContentLoaded', toggleHeader);

window.addEventListener('resize', () => {
    if (window.innerWidth > 1023) {
        getUnTeatherPoint(footer);
    }
});

window.addEventListener('scroll', toggleHeader);
